import React, { useState } from 'react';
import { Alert, Button, Input, Modal, Tooltip, notification } from 'antd';
import { CommentOutlined, PlusOutlined } from '@ant-design/icons';
import ordersService from '../../../services/ordersService';

const OrderTaskNoteButton = ({ order, onSaved, viewOnly = false, showLabel = false }) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const readOnly = viewOnly || ['completed', 'collected'].includes(String(order.order_status || '').trim().toLowerCase());
  const label = viewOnly ? `Read task note #${order.id}` : `${readOnly ? 'View' : 'Edit'} order note #${order.id}`;

  const show = () => {
    setNote(order.order_notes || '');
    setError(null);
    setOpen(true);
  };

  const save = async () => {
    if (readOnly || saving) return;
    setSaving(true);
    setError(null);
    try {
      const updated = await ordersService.updateTaskNote(order.id, note);
      setOpen(false);
      notification.success({ message: 'Order note saved' });
      onSaved?.(updated);
    } catch (failure) {
      const data = failure?.response?.data;
      setError(Object.values(data?.errors || {}).flat()[0] || data?.message || 'The note could not be saved. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return <>
    <Tooltip title={readOnly ? 'Read task note' : 'Add or edit task note'}>
      <Button type="text" aria-label={label} className={order.order_notes ? 'text-blue-600' : undefined}
        icon={<span className="relative inline-flex"><CommentOutlined />{!readOnly && !order.order_notes && <PlusOutlined className="absolute -right-1 -top-1 text-[8px]" />}</span>}
        onClick={show}>{showLabel ? 'Read task note' : null}</Button>
    </Tooltip>
    <Modal title={`Order note #${order.id}`} open={open} width={560}
      onCancel={() => setOpen(false)} onOk={readOnly ? () => setOpen(false) : save}
      okText={readOnly ? 'Close' : 'Save note'} cancelButtonProps={{ disabled: saving, style: readOnly ? { display: 'none' } : undefined }}
      confirmLoading={saving} closable={!saving} maskClosable={!saving}>
      <p className="mb-3 text-sm text-gray-600">This note is for this order only and is shown in its driver task. Notes can be changed before the order is completed or collected.</p>
      {error && <Alert type="error" showIcon message={error} className="mb-3" />}
      {readOnly ? <p className="whitespace-pre-wrap break-words">{note || 'No order note has been added.'}</p> : <>
        <label htmlFor={`order-note-${order.id}`} className="mb-1 block text-sm font-medium">Order note</label>
        <div className="pb-6">
          <Input.TextArea id={`order-note-${order.id}`} value={note} onChange={event => setNote(event.target.value)}
            maxLength={2000} showCount rows={5} disabled={saving} />
        </div>
      </>}
    </Modal>
  </>;
};

export default OrderTaskNoteButton;
